export * from './IconSearchFilled';
